import React, { Component } from 'react';
import { Panel,Row,Col, Alert } from 'react-bootstrap';
import pay30 from '../30.png';
import pay90 from '../90.png';
import pay120 from '../120.png';
import pay180 from '../180.png';

class Pay extends Component {
  render() {
    return (
      <div>
            <Row>
            <Alert bsStyle="info">
                <Col><strong>付款时请在备注中注明您的用户名。</strong></Col>
              </Alert>
            </Row>
            <Row>
              <Col xs={12} md={3}>
                <Panel>
                  <Panel.Heading>
                    月付费
                  </Panel.Heading>
                  <Panel.Body>
                    <div>30元/月</div>
                    <br/>
                    <div><img src={pay30} width="150" alt="付款" /></div> 
                  </Panel.Body>
                </Panel>
              </Col>
              <Col xs={12} md={3}>
                <Panel>
                  <Panel.Heading>
                    季付费
                  </Panel.Heading>
                  <Panel.Body>
                    <div>90元/季度，平均22.5元/月</div>
                    <br/>
                    <div><img src={pay90} width="150" alt="付款" /></div>                    
                  </Panel.Body>
                </Panel>
              </Col>
              <Col xs={12} md={3}>
                <Panel>
                  <Panel.Heading>
                    半年付费
                  </Panel.Heading>
                  <Panel.Body>
                    <div>120元/半年，平均20元/月</div>
                    <br/>
                    <div><img src={pay120} width="150" alt="付款" /></div> 
                  </Panel.Body>
                </Panel>
              </Col>
              <Col xs={12} md={3}>
                <Panel>
                  <Panel.Heading>
                    年付费
                  </Panel.Heading>
                  <Panel.Body>
                    <div>180元/年，平均15元/月</div>
                    <br/>
                    <div><img src={pay180} width="150" alt="付款" /></div> 
                  </Panel.Body>
                </Panel>
              </Col>
            </Row>
      </div>
    )
  }
}


export default Pay;



// WEBPACK FOOTER //
// ./src/components/Pay.js